import i18n from 'modules/core/lib/i18n'

export default function checkbox(list: string[]): string[] {
  const values = {
    zero: i18n.t('common.false'),
    one: i18n.t('common.true'),
  }

  return list.map((value: string) => {
    const key = parseInt(value) === 1 ? 'one' : 'zero'

    return values[key]
  })
}
